const SERVER_IP = "localhost";
const SERVER_PORT = "8000";
const TRANSPORTER_NAME = "SHREE ASHOK TRANSPORT SERVICE"


const USE_OVERLAY = true;

const getLocalFlag = () => {
    try{
        let lo = localStorage.getItem("local_flag") === 'true';
        console.log("Inansdsnns", lo);
      return lo
    } catch(e){
      return false
    }
  }
var SERVER_URL = ""
if (getLocalFlag()){
    console.log("in if")
    SERVER_URL = "https://atsbe.techiteasy.co.in";
}
else{
    console.log("in else")
    SERVER_URL = "https://atsbe.techiteasy.co.in";
    // const SERVER_URL = "https://d7edf369be0e55.localhost.run";
}
// SERVER_URL = "http://" + SERVER_IP + ":" + SERVER_PORT;
var PRINT_SERVER_URL = "https://print.techiteasy.co.in";

export { SERVER_URL, USE_OVERLAY, TRANSPORTER_NAME, PRINT_SERVER_URL};
